// Mirrors backend/src/apply_app/rules/answer_quality.py so the page can explain before submitting.
// The server stays the authority: it applies the same rule.

export type AnswerRule = { min_chars: number; min_words: number; min_distinct_letters: number };

const WORD = /[\p{L}\p{N}_]+/gu;
const LETTER = /\p{L}/u;

export function answerProblem(text: string, rule: AnswerRule): string | null {
  const clean = text.split(/\s+/).filter(Boolean).join(" ");
  if (clean.length < rule.min_chars) {
    return `Please write at least ${rule.min_chars} characters (you have ${clean.length}).`;
  }
  const words = (clean.match(WORD) ?? []).map((w) => w.toLowerCase());
  if (words.length < rule.min_words) return `Please write at least ${rule.min_words} words.`;
  const letters = new Set([...clean].filter((c) => LETTER.test(c)).map((c) => c.toLowerCase()));
  if (
    letters.size < rule.min_distinct_letters ||
    new Set(words).size < Math.min(3, rule.min_words)
  ) {
    return "This doesn't look like an answer yet. Please write it in your own words.";
  }
  return null;
}
